const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim();

let initialized = false;

export function initGA4() {
  if (!measurementId || initialized || typeof window === "undefined") {
    return;
  }
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId);
}

export function sendGA4PageView(path) {
  if (!measurementId || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("config", measurementId, { page_path: path });
}
